import { Component } from '@angular/core';
import { CaptureHistoryItemTypeBaseComponent } from '../capture-history-item-type-base/capture-history-item-type-base.component';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';


@Component({
    selector: 'app-capture-history-item-type-developer-chore-updated',
    templateUrl: './capture-history-item-type-developer-chore-updated.component.html',
    imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent]
})
export class CaptureHistoryItemTypeDeveloperChoreUpdatedComponent extends CaptureHistoryItemTypeBaseComponent {
  get references() {
    return this.captureHistoryItem.data?.references;
  }

  get note() {
    return this.captureHistoryItem.data?.note;
  }
}
